exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bqvRa {\n  font-family: 'Josefin Sans';\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 26px;\n  text-transform: uppercase;\n  text-align: center;\n  color: #A89A72;\n  background-color: #F6F4F0;\n  line-height: 50px;\n  margin-bottom: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"modalTitle": "bqvRa"
};